import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { homeRouteForOfficer } from '../routing/portal-home';

/** Authenticated default landing (respects active role home). */
export function portalHomeUrlTree(): UrlTree {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.needsRoleChoice()) {
    return router.createUrlTree(['/login']);
  }
  return router.createUrlTree([homeRouteForOfficer(auth.officer())]);
}
